import(/* webpackMode: "eager" */ "/app/src/app/[locale]/forgot-password/page.tsx");
